import React, { useEffect, useState } from "react";
import { ToBinRackingWrapper } from "./toBinRacking.style";
import { connect } from "react-redux";
import BinTable from "../../components/BinTable/BinTable";
import TitleWrapper from "../../../../components/TitleWrap/TitleWrap";
import TMLoader from "../../../../components/Loader/Loader";
import { productsYetToRacked, rackItemsToBin } from "../../service/service";
import { Result, Switch, Tabs, message } from "antd";
import {
  ALREADY_RACKED,
  API_TYPE,
  SOMETHING_WENT_WRONG,
  SUBMITTED,
  warehouseId,
} from "../../../../constants";
import TOQtyModal from "../../components/TOQtyModal/TOQtyModal";
import { handleError } from "../../../../redux/makeApiCall";
import { getAllReasons } from "../../helper/binHelper";

const ToBinRacking = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isRackingCompleted, setIsRackingCompleted] = useState(false);
  const [noData, setNoData] = useState(false);

  const [reasonMaster, setReasonMaster] = useState({
    moreQtyReasons: [],
    lessQuantityReasons: [],
    rackerReasons: [],
  });
  const [
    {
      isSelected,
      productName,
      productCode,
      batchNumber,
      binNumber,
      binLocation,
      pendingQuantity,
      taskPickingId,
      taskId,
      expiryDate,
    },
    setSelectedRecord,
  ] = useState({ isSelected: false });
  const columns = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      align: "center",
      filter: true,
    },
    {
      title: "Batch Number",
      dataIndex: "batchNumber",
      key: "batchNumber",
      align: "center",
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      key: "pendingQuantity",
      align: "center",
    },
  ];
  const getData = async () => {
    setIsLoading(true);
    try {
      const params = {
        access_token: props.access_token,
      };
      const response = await productsYetToRacked(params);
      if (
        response.data.statusCode === 200 &&
        Array.isArray(response.data.responseData)
      ) {
        const rackingComplete = response.data.responseData.every(
          (item) => item.racked
        );
        if (rackingComplete) {
          setIsRackingCompleted(true);
        } else {
          const temp = response.data.responseData.map((item) => {
            return {
              ...item,
              disabled: item.racked,
            };
          });
          setData(temp);
        }
      } else if (response.data.statusCode === 204) {
        setNoData(true);
      } else {
        throw new Error(response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      message.error(error.message || SOMETHING_WENT_WRONG);
    }
  };
  const rowClickHandler = ({ disabled, ...record }) => {
    if (disabled) {
      message.error(ALREADY_RACKED);
      return;
    }
    setSelectedRecord({ isSelected: true, ...record });
  };
  const onRackMedicine = async (selectedQty, selectedReason, selectedRack) => {
    setIsLoading(true);
    try {
      const params = {
        data: {
          productCode: productCode,
          batchNumber: batchNumber,
          oldBinNumber: binNumber,
          binNumber: selectedRack,
          binLocation: binLocation,
          availableQty: selectedQty,
          productName: productName,
          taskPickingId: taskPickingId,
          expiryDate: expiryDate,
          reasonId: selectedReason ? selectedReason : null,
        },
        taskId: taskId,
        warehouseId: warehouseId,
        access_token: props.access_token,
      };
      const response = await rackItemsToBin(params);
      if (response?.data?.statusCode === 200) {
        if (response?.data?.responseData?.isFullyRacked) {
          setIsRackingCompleted(true);
          setIsLoading(false);
          setSelectedRecord({ isSelected: false });
        } else {
          message.success(SUBMITTED);
          setSelectedRecord({ isSelected: false });
          getData();
        }
      } else {
        throw new Error(response.data.message ?? SOMETHING_WENT_WRONG);
      }
    } catch (error) {
      message.error(handleError(error, API_TYPE.NEW));
      setIsLoading(false);
    }
  };
  const fetchReasons = async () => {
    const { rackerReasons } = await getAllReasons({
      access_token: props.access_token,
      isRacker: true,
    });
    setReasonMaster({ ...reasonMaster, rackerReasons });
  };
  useEffect(() => {
    getData();
    fetchReasons();
  }, []);
  const unSelectRecord = () => {
    setSelectedRecord({ isSelected: false });
  };
  if (noData) {
    return (
      <Result
        status="info"
        title="Nothing to rack !"
        extra={
          <button
            className="bbtn"
            disabled={isLoading}
            onClick={() => props.history.push("/to-bin-racker")}
          >
            Go to home
          </button>
        }
      />
    );
  }
  return (
    <ToBinRackingWrapper>
      {isLoading && <TMLoader />}

      {isRackingCompleted ? (
        <div className="centerScreen">
          <Result
            status="success"
            title="Racking Complete !"
            extra={
              <button
                className="bbtn"
                disabled={isLoading}
                onClick={() => props.history.push("/to-bin-racker")}
              >
                Go to home
              </button>
            }
          />
        </div>
      ) : (
        <div className="centerScreen">
          <TitleWrapper title={"TO Bin Racking"} />

          <div className="tableWrapper">
            <Tabs
              defaultActiveKey="1"
              items={[
                {
                  label: `Not Racked`,
                  key: "1",
                  children: (
                    <BinTable
                      columns={columns}
                      dataSource={data.filter((item) => item?.racked === false)}
                      onRowClick={rowClickHandler}
                    />
                  ),
                },
                {
                  label: `Racked`,
                  key: "2",
                  children: (
                    <BinTable
                      columns={columns}
                      dataSource={data.filter((item) => item?.racked === true)}
                      onRowClick={rowClickHandler}
                    />
                  ),
                },
              ]}
            />
          </div>
        </div>
      )}
      {isSelected ? (
        <TOQtyModal
          close={unSelectRecord}
          isRacker={true}
          data={{
            productCode,
            batchNumber,
            binNumber,
            binLocation,
            availableQty: pendingQuantity,
            productName,
          }}
          confirm={onRackMedicine}
          reasonMaster={reasonMaster}
        />
      ) : null}
    </ToBinRackingWrapper>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

export default connect(mapStateToProps, {})(ToBinRacking);
